import i18n from "@/src/i18n";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { Nullable } from "@core/domain/types/nullable.type";
import type { Plot } from "@farm/domain/models/plot.model";
import type { FarmRepository } from "@farm/domain/repositories/farm.repository";
import { farmTypes } from "@farm/farm-types.di";
import { RecuperableModelError } from "@iot-platform/core";
import { inject, injectable } from "inversify";

@injectable()
export class FarmAddPlotUseCase {
    constructor(
        @inject(farmTypes.repositories.FarmRepository)
        private readonly farmRepository: FarmRepository,
    ) {}

    async execute(
        farmId: number,
        feature: GeoJSON.Polygon,
    ): Promise<Nullable<Plot>> {
        const result = await this.farmRepository.addPlot(farmId, feature);

        return result.match(
            (plot) => {
                ToastManagerRepository.success(i18n.t("farm:map.plotCreated"));
                return plot;
            },
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);
                    return error.instance as Plot;
                }

                ToastManagerRepository.error(error.message);
                return null;
            },
        );
    }
}
